import { render, staticRenderFns } from "./FormElementNotice.vue?vue&type=template&id=af6e514e"
import script from "./FormElementNotice.vue?vue&type=script&lang=js"
export * from "./FormElementNotice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports